import { Link, useLocation } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { useVelocityChat } from "./useVelocityChat";
import { ChatPanel } from "./ChatPanel";
import { X, Sparkles, Maximize2 } from "lucide-react";

export function VelocityAIWidget({ open, onClose }) {
  const { user } = useAuth();
  const loc = useLocation();
  const chat = useVelocityChat({ user });
  if (!open || loc.pathname === "/chat") return null;
  return (
    <div className="fixed inset-0 z-50 sm:inset-auto sm:bottom-5 sm:right-5 sm:w-[420px] sm:h-[640px] sm:max-h-[85vh] flex flex-col rounded-none sm:rounded-2xl border border-slate-800 bg-[#05070d] text-slate-100 shadow-2xl shadow-cyan-500/10 overflow-hidden" data-testid="ai-widget">
      <div className="h-12 shrink-0 flex items-center gap-2 px-3 border-b border-slate-800 bg-[#070b14]">
        <Sparkles className="w-4 h-4 text-cyan-300" /><span className="text-sm font-semibold flex-1">Velocity AI</span>
        <button onClick={() => chat.create()} className="text-xs text-slate-400 hover:text-white px-2" data-testid="ai-widget-new">New</button>
        <Link to="/chat" onClick={onClose} className="p-1.5 rounded-lg text-slate-400 hover:text-white hover:bg-slate-800" aria-label="Open full workspace" data-testid="ai-widget-expand"><Maximize2 className="w-4 h-4" /></Link>
        <button onClick={onClose} className="p-1.5 rounded-lg text-slate-400 hover:text-white hover:bg-slate-800" aria-label="Close" data-testid="ai-widget-close"><X className="w-4 h-4" /></button>
      </div>
      <div className="flex-1 min-h-0"><ChatPanel chat={chat} compact /></div>
    </div>
  );
}
